import mockProfile from '../../__mockData/mockProfile.json';
import { AccountType, DynamicObjectInterface, UserLoginModel } from '../type';
import { AxiosUtilsType, axiosGet, axiosPost } from './axiosUtils';
import './axiosInterceptor';

const authService = {
  async doLogin(user: UserLoginModel) {
    return await axiosPost(
      `auth/login`,
      {
        amwayId: user.amwayId,
        name: user.name,
        password: user.password,
      },
      mockProfile,
    );
  },

  async forgotPassword(username: string, email: string) {
    return await axiosPost(
      `auth/forgetPassword`,
      {
        loginId: username,
        email: email,
      },
      mockProfile,
    );
  },

  async validate() {
    return await axiosPost(`auth/validate`, undefined, mockProfile);
  },

  async getUserAccount(account?: AccountType): AxiosUtilsType {
    return await axiosPost(`auth/getUserAccount`, { account });
  },

  async getUserAccountParty(account?: AccountType): AxiosUtilsType {
    return await axiosPost(`auth/getUserAccountParty`, { account });
  },

  async getUserAccountAdmin(aboId: string): AxiosUtilsType {
    return await axiosPost(`auth/getUserAccountAdmin`, { aboId });
  },

  async getAppToken(user?: DynamicObjectInterface): AxiosUtilsType {
    return await axiosPost(`auth/getAppToken`, user);
  },

  async getUsernameToken(username: DynamicObjectInterface) {
    return await axiosGet(`/public/getUsernameToken?username=${username}`);
  },
  async getCustEnrollmentDetails(payload: DynamicObjectInterface) {
    return await axiosPost(`/public/getCustEnrollmentDetails`, payload);
  },
  async getRequestToken(payload: DynamicObjectInterface) {
    return await axiosPost(`auth/requestToken`, payload);
  },
  async getRefreshToken(payload: DynamicObjectInterface) {
    return await axiosPost(`auth/refreshToken`, payload);
  },
};

export default authService;
